import { CardDetailsState } from './types';

const defaultCardDetailsProviderState: CardDetailsState = {
  selectedCard: null,
  selectedPaymentCardIdentifications: null,
  selectedCardAction: null,
  cardTransactionsData: null,
  cardTransactionsFilters: { pageNumber: 0, pageSize: 10 },
  cardTransactionsPagination: { pageNumber: 0, pageSize: 10 },
  selectedCardTransaction: null,
  cardDetailsData: null,
  cardTransactionDetailsData: null,
  errorState: {
    cardTransactionsDataError: undefined,
    cardDetailsDataError: undefined,
  },
  loadingState: {
    isLoadingCardTransactionsData: false,
    isLoadingCardDetailsData: false,
  },
  onSetSelectedCard: () => {},
  onCardTransactionSelect: (transactionNo: string) => {},
  onCardTransactionListFiltersChange: () => {},
};

export { defaultCardDetailsProviderState };
